<template>
  <div id="indexhome">
    <div class="aside-col">
      <el-menu class="menu" :default-active="$route.path" router :collapse="isCollapse" background-color="initial"
        text-color="#fff" active-text-color="#fff" :collapse-transition="false" :unique-opened="true"
        style="text-align: left;">
        <router-link to="/indexhome/mapview" replace>
          <i class="el-icon-s-home"
            style="color: #fff;float: left;font-size: 22px;cursor: pointer;margin: 18px 10px 0px 23px;"></i>
          <span class="list_title" style="font-size: 16px;">首页</span>
        </router-link>
        <el-submenu :index="item.id.toString()" v-for="(item, index) in groupList" :key="index"
          :collapse-transition="false">
          <template slot="title">
            <i :class="[item.icon]"></i>
            <span style="font-size: 16px;">{{ item.title }}</span>
          </template>
          <el-menu-item-group v-if="item.childs">
            <el-menu-item @click="seeShare(itemtwo)" :index="'/indexhome' + itemtwo.href"
              v-for="(itemtwo, index) in item.childs" :key="index" replace>{{ itemtwo.title }}</el-menu-item>
          </el-menu-item-group>
        </el-submenu>
      </el-menu>
    </div>
    <div class="main-coled">
      <span class="list_title">万安迪环境空气质量物联网平台</span>
      <router-link to="/Home" replace>
        <i class="el-icon-s-platform" style="color: #fff;float: left;font-size: 22px;margin: 16px;cursor: pointer;"></i>
      </router-link>
      <el-dropdown placement="bottom" trigger="click" style="float: right;margin-right: 15px;">
        <img src="https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png" class="img-avatar">
        <span style="color: #fff;line-height: 55px;font-size: 22px;">{{ userName }}</span>
        <el-dropdown-menu slot="dropdown"
          style="margin-top:4px;width: 150px;text-align: center;box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.4)">
          <el-dropdown-item>
            <router-link to="/indexhome/mycenter" replace style="color: #000;text-decoration: auto;">
              <p style="font-size: 16px;">个人中心</p>
            </router-link>
          </el-dropdown-item>
          <el-dropdown-item>
            <p @click="loginOut" v-loading.fullscreen.lock="fullscreenLoading" style="color: #000;font-size: 16px;">退出登录
            </p>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <!-- <div class="demo-type" style="float: right;margin-right: 10px;">
        <img src="https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png" class="img-avatar">
        <span style="color: #fff;line-height: 55px;font-size: 20px;">{{ userName }}</span>
        <ul class="list-ul">
          <li>
            <router-link to="/indexhome/mycenter" replace style="color:#000000;">个人中心
            </router-link>
          </li>
          <li @click="loginOut" v-loading.fullscreen.lock="fullscreenLoading">退出登录</li>
        </ul>
      </div> -->
    </div>
    <div class="main-col">
      <keep-alive>
        <!-- 需要缓存的视图组件 -->
        <router-view v-if="$route.meta.keepAlive">
        </router-view>
      </keep-alive>
      <!-- 不需要缓存的视图组件 -->
      <router-view v-if="!$route.meta.keepAlive"></router-view>
    </div>
  </div>
</template>

<script>
import { clearLoginInfo } from "../utils";

export default {
  name: "indexhome",
  data() {
    return {
      isCollapse: false,
      fullscreenLoading: false,
      modifyPasswordVisible: false,
      modifymobilephone: false,
      modifyPasswordForm: {
        odlPassword: "",
        newPassword: "",
        verifyPassword: ""
      },
      loginForm: {
        mobile: "",
        code: ""
      },
      title: "",
      userName: "",
      groupList: [],
      zoom: 11,
      center: [112.5862, 37.8268],
      mapStyle: "amap://styles/whitesmoke"
    };
  },
  methods: {
    //获取手机验证码
    phone() {
      if (this.loginForm.mobile == "") {
        this.$message.error("请输入手机号码不能为空");
      } else {
        this.$http({
          url: this.$http.adornUrl("/sms/send/" + this.loginForm.mobile),
          method: "POST",
          data: this.$http.adornData(this.loginForm)
        }).then(({ data }) => {
          if (data && data.code === 200) {
            this.$message.success("短信发送成功");
          } else {
            this.$message.error(data.msg);
          }
        });
      }
    },
    //退出登录
    loginOut() {
      this.$http({
        url: this.$http.adornUrl("/login/out"),
        method: "get",
        params: this.$http.adornParams()
      }).then(({ data }) => {
        if (data && data.code === 200) {
          this.$message({
            message: data.msg,
            type: "success",
            duration: 1000
          });
        }
      });
      clearLoginInfo();
      sessionStorage.clear();
      this.fullscreenLoading = true;
      setTimeout(() => {
        this.fullscreenLoading = false;
        this.$router.replace({ path: "/" });
        location.reload();
      }, 1000);
    },
    seeShare(item) {
      console.log(item);
      let routeUrl = this.$router.resolve({});
      //判断跳转路径是否包含了https
      if (routeUrl.href.indexOf("https") !== -1) {
        //回到首页
        this.$router.push({ name: "mapview" });
        window.open("https:/" + routeUrl.href.split("https:")[1], "_blank");
      }
    }
  },
  mounted() {
    console.log(this.$store);
  },
  created() {
    let user = JSON.parse(sessionStorage.getItem("user") || "[]");
    this.groupList = JSON.parse(sessionStorage.getItem("menu") || "[]").childs;
    this.title = JSON.parse(sessionStorage.getItem("title") || "[]");
    this.userName = user.username;
    this.$http({
      url: this.$http.adornUrl("bigScreen/hierarchyTree/-999"),
      method: "get"
    }).then(({ data }) => {
      if (data && data.code === 200) {
        sessionStorage.setItem(
          "hTree",
          JSON.stringify(data.data.hTree || "[]")
        );
      }
    });
  }
};
</script>
<style scoped>
@import "../assets/css/indexhome.css";

.list_title {
  height: 55px;
  display: inline-block;
  line-height: 55px;
  color: #fff;
  font-size: 20px;
  font-weight: bold;
}

/deep/ .el-submenu__title:hover {
  background-color: #409eff !important;
}

/* :deep(.el-icon) {
  font-size: 1em;
} */
</style>



// WEBPACK FOOTER //
// src/pages/indexhome.vue